import React, { FunctionComponent } from 'react'

import { FileDropzone } from '../..//file'
import { AddFileToMedicalEventProps } from './AddFileToMedicalEvent.model'

export const AddFileToMedicalEvent: FunctionComponent<AddFileToMedicalEventProps> = ({
  addFilesToMedicalEvent,
}) => <FileDropzone type="file" onDrop={addFilesToMedicalEvent} />
